import { FC } from 'react';
import { AllieText } from '../../../../../components';
import { ContentText } from './ContentText';
import { UserAssigned } from './ContentUserAssigned';
import { ContentSelect } from './ContentSelect';
import { ContentCustom } from './ContentCustom';
import { ContentDate } from './ContentDate';
import { DataContentBaseProps } from './DataContent.types';

export type ContentType = 'text' | 'userAssigned' | 'select' | 'custom' | 'date';

const MapContentType: Record<string, Function> = {
  text: ContentText,
  userAssigned: UserAssigned,
  select: ContentSelect,
  custom: ContentCustom,
  date: ContentDate,
};

export interface DataContentProps extends DataContentBaseProps {
  title: string;
  type: ContentType;
}

export const DataContent: FC<DataContentProps> = ({ title, type, ...props }) => {
  const Content = MapContentType[type];
  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <AllieText type="h4" weight={600}>
          {title}
        </AllieText>
      </div>
      <Content {...props} />
    </div>
  );
};
